// extracted by mini-css-extract-plugin
export default {"list":"NavList_list__Jqumx","text":"NavList_text__b6v0a","link":"NavList_link__RG2CN","icon":"NavList_icon__A7wAc","linkActive":"NavList_linkActive__M27N3"};